import React, { useState } from "react";

export default function SmsTemplate() {
  const [formData, setFormData] = useState({
    subscriptionFreeMsg: "",
    subscriptionFreeMsgArabic: "",
    subscriptionChargeMsg: "",
    subscriptionChargeMsgArabic: "",
    renewalMsg: "",
    renewalMsgArabic: "",
    lowBalanceMsg: "",
    lowBalanceMsgArabic: "",
    alreadySubscribeMsg: "",
    alreadySubscribeMsgArabic: "",
    unSubscribeMsg: "",
    unSubscribeMsgArabic: "",
    notSubscribeMsg: "",
    notSubscribeMsgArabic: "",
    wrongKeywordMsg: "",
    wrongKeywordMsgArabic: "",
  });

  // Add state for validation errors
  const [errors, setErrors] = useState({});

  const templateFields = [
    {
      english: {
        name: "subscriptionFreeMsg",
        label: "Subscription Free Trial",
        placeholder: "Subscription free trial",
        autocomplete: "subscriptionFreeMessage",
      },
      arabic: {
        name: "subscriptionFreeMsgArabic",
        label: "Subscription Free Trial (Arabic)",
        placeholder: "Subscription free trial",
        autocomplete: "subscriptionFreeMessageArabic",
      },
    },
    {
      english: {
        name: "subscriptionChargeMsg",
        label: "Subscription Charge Message",
        placeholder: "Subscription Charge Message",
        autocomplete: "subscriptionChargeMessage",
      },
      arabic: {
        name: "subscriptionChargeMsgArabic",
        label: "Subscription Charge Message (Arabic)",
        placeholder: "Subscription Charge Message Arabic",
        autocomplete: "subscriptionChargeMessageArabic",
      },
    },
    {
      english: {
        name: "renewalMsg",
        label: "Renewal Message",
        placeholder: "Renewal Message",
        autocomplete: "renewalMessage",
      },
      arabic: {
        name: "renewalMsgArabic",
        label: "Renewal Message (Arabic)",
        placeholder: "Renewal Message Arabic",
        autocomplete: "renewalMessageArabic",
      },
    },
    {
      english: {
        name: "lowBalanceMsg",
        label: "Low Balance Message",
        placeholder: "Low Balance Message",
        autocomplete: "lowBalanceMessage",
      },
      arabic: {
        name: "lowBalanceMsgArabic",
        label: "Low Balance Message (Arabic)",
        placeholder: "Low Balance Message Arabic",
        autocomplete: "lowBalanceMessageArabic",
      },
    },
    {
      english: {
        name: "alreadySubscribeMsg",
        label: "Already Subscribe Message",
        placeholder: "Already Subscribe Message",
        autocomplete: "alreadySubscribeMessage",
      },
      arabic: {
        name: "alreadySubscribeMsgArabic",
        label: "Already Subscribe Message (Arabic)",
        placeholder: "Already Subscribe Arabic Message",
        autocomplete: "alreadySubscribeMessageArabic",
      },
    },
    {
      english: {
        name: "unSubscribeMsg",
        label: "Un-Subscribe Message",
        placeholder: "Un-Subscribe Message",
        autocomplete: "unSubscribeMessage",
      },
      arabic: {
        name: "unSubscribeMsgArabic",
        label: "Un-Subscribe Message (Arabic)",
        placeholder: "Un-Subscribe Arabic Message",
        autocomplete: "unSubscribeMessageArabic",
      },
    },
    {
      english: {
        name: "notSubscribeMsg",
        label: "Not Subscribe Message",
        placeholder: "Not Subscribe Message",
        autocomplete: "notSubscribeMessage",
      },
      arabic: {
        name: "notSubscribeMsgArabic",
        label: "Not Subscribe Message (Arabic)",
        placeholder: "Not Subscribe Arabic Message",
        autocomplete: "notSubscribeMessageArabic",
      },
    },
    {
      english: {
        name: "wrongKeywordMsg",
        label: "Wrong Keyword Message",
        placeholder: "Not Subscribe Message",
        autocomplete: "wrongKeywordMessage",
      },
      arabic: {
        name: "wrongKeywordMsgArabic",
        label: "Wrong Keyword Message (Arabic)",
        placeholder: "Not Subscribe Message Arabic",
        autocomplete: "wrongKeywordMessageArabic",
      },
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user types
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Check each field for minimum length
    Object.keys(formData).forEach((key) => {
      if (formData[key].length < 10) {
        newErrors[key] = "Minimum 10 characters required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Handle form submission
      console.log(formData);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="box-header">
                  <div className="row">
                    <div className="col-md-6">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb breadcrumb_bg">
                          <li className="breadcrumb-item">
                            <a className="breadcrumb_1">
                              Setting & Configuration
                            </a>
                          </li>
                          <li
                            className="breadcrumb-item active breadcrumb_2"
                            aria-current="page"
                          >
                            Sms Template
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="box-body">
                  <form
                    className="form-horizontal mt-2"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    {templateFields.map((field, index) => (
                      <div className="row" key={index}>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="font-weight-bold">
                              {field.english.label}
                            </label>
                            <textarea
                              type="text"
                              className={`form-control ${
                                errors[field.english.name] ? "is-invalid" : ""
                              }`}
                              name={field.english.name}
                              value={formData[field.english.name]}
                              onChange={handleChange}
                              maxLength="2000"
                              placeholder={field.english.placeholder}
                              autoComplete={field.english.autocomplete}
                            />
                            <div className="invalid-feedback d-block error">
                              {errors[field.english.name] || ""}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="font-weight-bold">
                              {field.arabic.label}
                            </label>
                            <textarea
                              type="text"
                              className={`form-control ${
                                errors[field.arabic.name] ? "is-invalid" : ""
                              }`}
                              name={field.arabic.name}
                              value={formData[field.arabic.name]}
                              onChange={handleChange}
                              maxLength="2000"
                              placeholder={field.arabic.placeholder}
                              autoComplete={field.arabic.autocomplete}
                            />
                            <div className="invalid-feedback d-block error">
                              {errors[field.arabic.name] || ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="modal-footer border-0">
                      <button className="btn btn-primary">Update</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
